export default {
  title: "Categories",
  subtitle: "Manage product categories",
  
  // Actions
  addNew: "Add New Category",
  createCategory: "Create Category",
  editCategory: "Edit Category",
  deleteCategory: "Delete Category",

  actions: {
    back: "Back",
    update: "Update",
    updating: "Updating...",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete"
  },
  
  // Fields
  fields: {
    name: "Category Name",
    hsCode: "HS Code",
    description: "Description",
    tax: "Tax Rate (%)",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At"
  },
  
  // Placeholders
  placeholders: {
    name: "Enter category name",
    hsCode: "Enter HS code",
    description: "Enter category description",
    tax: "Enter tax rate"
  },
  
  // Messages
  messages: {
    createSuccess: "Category created successfully",
    createError: "Failed to create category",
    updateSuccess: "Category updated successfully",
    updateError: "Failed to update category",
    deleteSuccess: "Category deleted successfully",
    deleteError: "Failed to delete category",
    deleteConfirm: "Are you sure you want to delete this category?",
    noCategories: "No categories found",
    loadingCategories: "Loading categories...",
    fetchError: "Failed to fetch categories"
  },
  
  // Validation
  validation: {
    nameRequired: "Category name is required",
    nameMinLength: "Category name must be at least 2 characters",
    nameMaxLength: "Category name must not exceed 100 characters",
    hsCodeRequired: "HS code is required",
    hsCodeFormat: "HS code must be in valid format",
    taxRequired: "Tax rate is required",
    taxMin: "Tax rate must be 0 or greater",
    taxMax: "Tax rate must not exceed 100",
    descriptionMaxLength: "Description must not exceed 500 characters"
  },
  
  // Table headers
  table: {
    name: "Name",
    hsCode: "HS Code",
    description: "Description",
    tax: "Tax (%)",
    status: "Status",
    actions: "Actions"
  },
  
  // Status options
  statusOptions: {
    active: "Active",
    inactive: "Inactive"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    categories: "Categories",
    create: "Create Category",
    edit: "Edit Category",
    view: "View Category"
  }
};
